/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupdeadline1Inputs */

const en_signupdeadline1 = /** @type {(inputs: Signupdeadline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up deadline`)
};

const de_signupdeadline1 = /** @type {(inputs: Signupdeadline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldeschluss`)
};

/**
* | output |
* | --- |
* | "Sign-up deadline" |
*
* @param {Signupdeadline1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupdeadline1 = /** @type {((inputs?: Signupdeadline1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupdeadline1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupdeadline1(inputs)
	return de_signupdeadline1(inputs)
});
export { signupdeadline1 as "signupDeadline" }